// extracted by mini-css-extract-plugin
export default {"component":"Bg9u7"};